import { GlobalController } from 'src/shared/global/GlobalController'
import BillingDashboard from './BillingDashboard.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [

  {
    path: ':link',
    name: 'billingDashboard',
    component: BillingDashboard,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
